module.exports = __webpack_public_path__ + "static/media/bruised_bone.8a747470.svg";